import { Navigate, Outlet, useLocation } from "react-router-dom";
import SideMenu from "./Menus/SideMenu";
import "./dashboard.css";
import { useEffect } from "react";
import Cookies from "universal-cookie";
import CookieInfoBar from "./CookieInfoBar";
import googleService from "../../services/GoogleService";

const cookies = new Cookies();

const Dashboard = () => {
    let location = useLocation();

    useEffect(() => {
        googleService.initialize();
    }, [location]);

    if (!cookies.get("twitch_user")) {
        return <Navigate to="/" />;
    }

    return (
        <>
            <SideMenu />
            <div className="middleSection">
                <Outlet /> {/* Child routes will be rendered here */}
            </div>
            <CookieInfoBar />
        </>
    );
};

export default Dashboard;
